export default __webpack_public_path__ + "2e79dfac64a3ca014779b468bd27a678.svg";